/**
 * Shared game registry instance. Engines register themselves here at
 * module load so the UI can look them up by id.
 */
import { chess } from './chess.js';
import { connectFour } from './connect-four.js';
import { GameRegistry } from './engine.js';
import { ticTacToe } from './tic-tac-toe.js';

export const gameRegistry = new GameRegistry();

gameRegistry.register(ticTacToe);
gameRegistry.register(connectFour);
gameRegistry.register(chess);

export { GameRegistry } from './engine.js';
export type { GameEngine, GameComponentProps, GameTerminal } from './engine.js';
